// extracted by mini-css-extract-plugin
module.exports = {"main_div":"Recommendation_main_div__2-P2Q","header_div":"Recommendation_header_div__3SNlh","content_div":"Recommendation_content_div__29U88"};